import { useEffect, useRef, useState } from "react";
import { useStyles } from "../../../Styles/styles";
import styles from './SizeAndWeightStyles.module.css';
import SingleDropDown from "../../SingleDropDown";
import { formatNameFromPersonObj } from "../../../utils/utils";
import clsx from 'clsx';
import CheckboxWithLabel from "../../CheckboxWithLabel";
import Required from "./Required/Required";


export const VehiclePersonField = ({
  disabled,
  incidentId,
  handleChange,
  dispatch,
  personType,
  person,
  address,
  phone,
  piss,
  incidentPeople,
  userRoles,
  checked,
  setChecked,
  locked,
  missingFields = [],
  ...props
}) => {
  const classes = useStyles();
  const inputLabel = useRef(null);
  const [labelWidth, setLabelWidth] = useState(0);
  const title = personType.charAt(0).toUpperCase() + personType.slice(1);
  const [addresses, setAddresses] = useState([]);
  const [phones, setPhones] = useState([]);

  const checkboxName = personType === "operator" ? "printOperator" : personType === "carrier" ? "printCarrier" : "printOwner"
  useEffect(() => {
    if (inputLabel.current) {
      setLabelWidth(inputLabel.current.offsetWidth);
    }
  }, []);

  useEffect(() => {
    let addressArr = [person?.personalAttribute?.mailingAddress, person?.personalAttribute?.homeAddress]
    let filteredAddressArr = addressArr.filter(a => !!a?.name)
    let phoneArr = [person?.personalAttribute?.phone, person?.personalAttribute?.cell]
    let filteredPhoneArr = phoneArr.filter(p => !!p)

    setAddresses(filteredAddressArr)
    setPhones(filteredPhoneArr)
  }, [person])

  useEffect(() => {
    if (!person && !locked) {
      //search the incidentPeople array for a person with the role of personType
      let match = incidentPeople.find(p => p?.role?.toUpperCase() === personType?.toUpperCase())
      if (match) {
        handleChange(match, 'UPDATE_PROPERTY', { property: personType })
      }
    }
  }, [handleChange, incidentPeople, person, personType, locked])

  useEffect(() => {
    if (person?.id && !address?.name && addresses[0]?.id && !locked) {
      handleChange(addresses[0], 'UPDATE_PROPERTY', { property: personType + "Address" })
    }
  }, [address, addresses, handleChange, person?.id, personType, locked])

  useEffect(() => {
    if (person?.id && !phone && phones[0] && !locked) {
      handleChange(phones[0], 'UPDATE_PROPERTY', { property: personType + "Phone" })
    }
  }, [address, addresses, handleChange, person?.id, personType, phone, phones, locked])

  if (!['operator', 'carrier', 'owner'].includes(personType)) {
    console.error('Invalid personType')
  }

  return (
    <div className={`${styles['flexRow']} ${styles['fillAvailable']}`}>
      <Required
        required={missingFields.some(field => field?.name === personType)}
        message={missingFields.find(field => field?.name === personType)?.error}
      >
        <SingleDropDown
          disabled={disabled}
          handleChange={(e) => handleChange(e.target.value, 'UPDATE_PROPERTY', { property: personType })}
          stateName={personType}
          value={person}
          options={incidentPeople}
          title={title}
          classStyle={clsx(classes.formControl, classes.fixedWidth, classes.flexMatchSize)}
          inputLabel={inputLabel}
          labelWidth={labelWidth}
          nameFormatter={formatNameFromPersonObj}
          userRoles={userRoles}
          {...props}
        />
      </Required>
      <SingleDropDown
        disabled={disabled}
        handleChange={(e) => handleChange(e.target.value, 'UPDATE_PROPERTY', { property: personType + "Address" })}
        stateName={'address'}
        value={address}
        options={addresses}
        title={title + '\xa0Mailing\xa0Address'}
        classStyle={clsx(classes.formControl, classes.fixedWidth, classes.flexMatchSize)}
        inputLabel={inputLabel}
        labelWidth={labelWidth}
        userRoles={userRoles}
        {...props}
      />
      <SingleDropDown
        disabled={disabled}
        handleChange={(e) => {
          let value = e.target.value
          //This will only be true if the blank object is selected. 
          if (typeof value === 'object') {
            value = ""
          }
          handleChange(value, 'UPDATE_PROPERTY', { property: personType + "Phone" })
        }}
        stateName={'phone'}
        value={phone}
        options={phones}
        title={title + '\xa0Phone'}
        classStyle={clsx(classes.formControl, classes.fixedWidth, classes.flexMatchSize)}
        inputLabel={inputLabel}
        labelWidth={labelWidth}
        userRoles={userRoles}
        {...props}
      />
      <Required
        required={missingFields.some(field => field?.name === checkboxName)}
        message={missingFields.find(field => field?.name === checkboxName)?.error}
      >
        <CheckboxWithLabel
          formStyle={clsx(classes.formControl, classes.flexMatchSize)}
          checked={checked}
          onChange={(e) => {
            handleChange(e.target.checked, 'UPDATE_PROPERTY', { property: personType === "owner" ? 'printOwner' : 'printCarrier' })
            //then send the opposite value to the other checkbox
            handleChange(!e.target.checked, 'UPDATE_PROPERTY', { property: personType === "owner" ? 'printCarrier' : 'printOwner' })
          }}
          stateName={"check"}
          title={personType === "operator" ? "Print to Report" : "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"}
          disabled={personType === "operator" || disabled}
          userRoles={userRoles}
          labelStyle={classes.reverseColumn}
          {...props}
        />
      </Required>
    </div>
  )
}

export default VehiclePersonField;
